module.exports = __webpack_public_path__ + "static/media/copyIcon.bb0d036e.svg";